import { Component, Vue, Prop } from  'vue-property-decorator';

@Component
export default class Header extends Vue{
    constructor(){
        super();
    }
    mounted(): void{
        console.log('this component is loaded');
    }
}